// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1Q69H","alert":"SettungsInbox_alert__3CLvm"};